/**
 * メッセージ一覧
 */
export const Messages = {
  ERR_401: 'セッションが切断されました。',
  ERR_403: 'セッション情報が変更されました。',

  ERR_DISPLAY_401: 'セッションが切断されました。',
  ERR_DISPLAY_403: 'セッション情報が変更されました。',
  ERR_DISPLAY_404: 'このページはアクセスできません。',
  ERR_DISPLAY_500: '時間を置いて再度アクセスして下さい。',
  ERR_INVALID_INPUT: '入力に誤りがあります。',
  ERR_INVALID_ISSUE: '必須項目(*が付与された項目)を入力してください。',
  ERR_INVALID_CREDENTIALS: 'IDまたはパスワードが異なります。',
  ERR_NO_SCHEDULE: 'スケジュールがありません。',
  ERR_NO_DATA: '該当データがありません。',
  ERR_NO_ACCOUNT: '該当のアカウントがありません。',
  ERR_OTHER: 'エラーが発生しました。',
  ERR_INTERNAL_SERVER_ERROR: 'エラーが発生しました。時間をおいて再度お試しください。',
  ERR_DIALOG_RETURN_LOGIN: 'エラーが発生しました。再ログインしてください。',
  ERR_UNSUPPORTED_CSV: 'CSVの異常を検知しました。この形式はサポートされていません',
  ERR_DIALOG_RETRY_OPERATION: 'エラーが発生しました。もう一度操作してください。',
  ERR_DIALOG_CONFLICT: '他の人が変更しています。上書きしますか？',
  ERR_DIALOG_CHECK_CONFLICT: '現在競合チェックは実行されています。時間をおいて再度実施してください。',
  ERR_DIALOG_CSV_CONFLICT: '現在該当ファイルの作業計画一括登録が行われています。時間をおいて再度実施して下さい。',
  ERR_DIALOG_UPDATE_CSV_CONFLICT: '現在該当ファイルの作業計画一括登録が行われています。時間をおいて再度検索の上、編集して下さい。',
  ERR_DIRTY: 'ページを移動する前に「更新」を押下するか\n編集モードを解除してください。',
  ERR_DIALOG_TIMEOUT: 'タイムアウトが発生しました。時間をおいて再度実施して下さい',
  ERR_DIALOG_ALREADY_DELETED: '既にアカウント: [1] は削除されています',
  ERR_CHK_INVALID_PASSWORD: 'パスワードは入力規則に準拠してください。',
  ERR_CHK_MISMATCH_PASSWORD: 'パスワードとパスワード（確認用）が一致しません。',

  ERR_DIALOG_ALREADY_REGISTER: '既に登録済みです。',
  EXECUTE_CONFLICT_CHECK: '競合チェックを開始しました。',
  EXECUTE_ISSUE_REGISTER: '登録が完了しました。',
  EXECUTE_CSV_REGISTER1: '登録を受け付けました。',
  EXECUTE_CSV_REGISTER2: '登録が完了したら作業計画参照・更新画面で参照できるようになります',
  EXECUTE_ISSUE_UPDATE: '更新が完了しました。',
  EXECUTE_CSV_UPDATE: '更新が完了しました。',
  EXECUTE_DELETE: '削除が完了しました。',
  EXECUTE_DELETE_WITH_NAME: 'アカウント:[1] の削除が完了しました。',
  EXECUTE_CHANGE_PASSWORD_SUCCESS: 'パスワードが変更されました',

  // エリア選択時のパンくずリストの最初の名前
  breadcrumb: '高輪GWシティ',
  // 選択される街区
  selectedBuilding: '4街区複合棟North',
  loginName: 'J社 ウラカワ太郎',
  // エリア選択画面
  area: {
    selectBuilding: '街区選択',
    selectArea: 'フロア選択',
    noSelect: 'ビル選択後にフロアが表示されます。',
    // エリア名 (4要素必須)
    names: ['2階', '6階 スカイロビー', '11階', '21階'],
    norobot: '担当はありません',
    note: '・プロトタイプでは，どの街区・どのフロアを選択しても4街区北棟の6階スカイロビーを表示します．\n・フロアの選択欄は，UIイメージの一例です．選択肢となるフロア数や元データの持ち方によって，選択方法は見直します．\n・実用化時には，街区やフロアを選択したタイミングで 多少 待ち時間が発生する可能性があります．',
  },
  main: {
    menu: {
      // 情報ボタン
      info: '情報パネル',
      // 凡例ボタン
      legend: '凡例',
      // 一括操作ボタン
      bulkcommand: '緊急時一括操作',
    },
  },
  commands: {
    // 常に前面に標示の文言
    showTop: {
      on: '常に前面に表示',
      off: '"常に前面に表示"を解除',
    },
  },
  devices: {
    note: '端末一覧に具体的にどのような項目を表示するかは，ロボットごとに取得できる情報の確認も含めて今後検討が必要です．\n（下記はある程度情報量を多く表示させたい場合のUIイメージ一例です',
  },
  notification: {
    status: {
      open: '未対応',
      ack: '対応中',
      closed: '対応済み',
    },
  },
};

export function formatMessage(template: string, ...args: string[]): string {
  return args.reduce(
    (msg, val, i) => msg.replace(`[${i + 1}]`, val),
    template
  );
}